module.exports = __webpack_public_path__ + "img/testabout_2.edf3597b.jpg";